import { Component, effect } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { AuthService } from './core/auth.service';
import { BrandingService } from './core/branding.service';
import { LocaleService } from './core/locale.service';
import { PushNotificationsService } from './core/push-notifications.service';
import { ErrorBannerComponent } from './shared/error-banner/error-banner.component';
import { SuspendedBannerComponent } from './shared/suspended-banner/suspended-banner.component';
import { WorkflowNoticeBannerComponent } from './shared/workflow-notice-banner/workflow-notice-banner.component';
import { SharedHeaderComponent } from './shared/header/shared-header.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SharedHeaderComponent, SidebarComponent, ErrorBannerComponent, SuspendedBannerComponent, WorkflowNoticeBannerComponent, ConfirmDialogModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  constructor(readonly auth: AuthService, locale: LocaleService, branding: BrandingService, pushNotifications: PushNotificationsService) {
    effect(() => locale.apply(this.auth.currentUser()?.preferredLocale));
    effect(() => (this.auth.currentUser() ? branding.applyForCurrentUser() : branding.reset()));
    effect(() => {
      if (this.auth.currentUser()) {
        void pushNotifications.refreshIfAlreadyGranted();
      }
    });
  }
}
